"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _Functions = require("../core/Functions");

var HoverProvider =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(HoverProvider, _React$Component);

  function HoverProvider(props) {
    var _this;

    (0, _classCallCheck2.default)(this, HoverProvider);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(HoverProvider).call(this, props));
    _this.state = {
      hovered: false
    };
    _this.handleMouseEnter = _this.handleMouseEnter.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleMouseLeave = _this.handleMouseLeave.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(HoverProvider, [{
    key: "handleMouseEnter",
    value: function handleMouseEnter(evt) {
      (0, _Functions.callIfPossible)(this.props.onMouseEnter, evt);
      if (this.state.hovered !== true) this.setState({
        hovered: true
      });
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave(evt) {
      (0, _Functions.callIfPossible)(this.props.onMouseLeave, evt);
      if (this.state.hovered !== false) this.setState({
        hovered: false
      });
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(evt) {
      (0, _Functions.callIfPossible)(this.props.onMouseMove, evt); // See https://git.hubteam.com/HubSpot/UIComponents/issues/3927

      if (this.state.hovered !== true) this.setState({
        hovered: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          hoveredProp = _this$props.hovered;
      var hovered = this.state.hovered;
      return children({
        hovered: hoveredProp != null ? hoveredProp : hovered,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        onMouseMove: this.handleMouseMove
      });
    }
  }]);
  return HoverProvider;
}(_react.default.Component);

HoverProvider.displayName = 'HoverProvider';
var _default = HoverProvider;
exports.default = _default;
module.exports = exports.default;